<!-- 提现  -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" class="btn-primary" @click="showDialog" v-if="permission.withdraw">{{ permission.withdraw }}</el-button>
            </div>
            <div class="search-ctn-right">
                <div class="search-name">时间</div>
                <i class="el-icon-date search-name time-btn" @click="timeVisible = true"></i>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border style="width: 100%">
                <el-table-column show-overflow-tooltip prop="CreateTime" label="申请日期"></el-table-column>
                <el-table-column show-overflow-tooltip prop="SName" label="申请人"></el-table-column>
                <el-table-column show-overflow-tooltip prop="Money" label="申请金额"></el-table-column>
                <el-table-column show-overflow-tooltip prop="StateName" label="支付方式"></el-table-column>
                <el-table-column show-overflow-tooltip prop="TransferAccountTime" label="到账日期"></el-table-column>
                <el-table-column show-overflow-tooltip prop="InAccountMoney" label="到账金额"></el-table-column>
                <el-table-column show-overflow-tooltip label="发票">
                    <template slot-scope="scope">
                        <div class="shop-msg" v-if="scope.row.InvoiceUrl">
                            <a :href="scope.row.InvoiceUrl" target="_blank">发票</a>
                        </div>
                        <div v-else>-</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" :before-close="cancelWithdrawal" width="800px">
            <el-form :model="WithdrawalData" :rules="rules" ref="formData" label-width="120px">
                <div class="canGetMoney">
                    可提现金额：
                    <span class="color-red">￥ {{ CanMoney }}</span>
                </div>
                <el-form-item label="提现金额(元)" prop="Money">
                    <el-input type="number" step="0.01" v-model.trim="WithdrawalData.Money" v-filter-special-char="WithdrawalData.Money"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model.trim="WithdrawalData.Remark" v-filter-special-char="WithdrawalData.Remark"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelWithdrawal">取 消</el-button>
                <el-button class="btn-primary" @click="applyWithdrawal">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="创建时间" :visible.sync="timeVisible" width="800px">
            <div class="dialog-content" v-if="timeVisible">
                <timePicker @timerSearch="timerSearch" :start="this.searchData.BeginDate" :end="this.searchData.EndDate"></timePicker>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
import timePicker from '@/components/common/timePicker';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    components: {
        timePicker,
        breadcrumb
    },
    name: '',
    data() {
        let checkPositive = this.$util.checkPositive;
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            userMsg: userMsg,
            timeVisible: false,
            canRequest: true,
            permission: {},
            WithdrawalData: {
                OperatorId: userMsg.EmployeeId,
                Operator: userMsg.Account,
                EntpId: userMsg.EntpId,
                Money: '',
                Remark: ''
            },
            CanMoney: '',
            dialogVisible: false,
            searchData: {
                EntpId: userMsg.EntpId,
                BeginDate: '',
                EndDate: '',
                limit: 15,
                page: 1,
                key: null
            },
            tableData: [],
            tableDataLength: 0,
            rules: {
                Money: [
                    { required: true, message: '请输入提现金额', trigger: 'blur' },
                    { required: false, validator: checkPositive, trigger: 'blur' }
                ]
            }
        };
    },
    mounted() {
        this.getTableData();
        this.getCanMoney();
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.permission = this.$util.getPermission('Withdraw');
    },
    methods: {
        timerSearch(timer) {
            this.timeVisible = false;
            this.searchData.BeginDate = timer.start;
            this.searchData.EndDate = timer.end;
            this.handleSearch();
        },
        resetSearch() {
            this.searchData = {
                EntpId: this.userMsg.EntpId,
                BeginDate: '',
                EndDate: '',
                limit: this.commonPageSize,
                page: 1,
                key: null
            };
        },
        // 取消提现
        cancelWithdrawal() {
            this.$util.clearValidate(this, 'formData');
            this.dialogVisible = false;
            this.WithdrawalData.Money = '';
            this.WithdrawalData.Remark = '';
        },
        // 申请提现
        applyWithdrawal() {
            if (this.WithdrawalData.Money > this.CanMoney) {
                this.$util.warningMsg('提现金额不能大于可提现金额');
                this.WithdrawalData.Money = this.CanMoney;
                return;
            }
            this.$refs.formData.validate(valid => {
                if (valid) {
                    if (!this.canRequest) {
                        return;
                    }
                    this.canRequest = false;
                    this.$util
                        .axiosPost({
                            url: '/api/RevenueManagement/ApplyWithdrawal',
                            data: this.WithdrawalData
                        })
                        .then(res => {
                            let data = res.data;
                            this.CanMoney = data.WithdrawCash;
                            this.$util.successMsg('提现成功');
                            this.dialogVisible = false;
                            this.WithdrawalData.Money = '';
                            this.WithdrawalData.Remark = '';
                            this.$util.clearValidate(this, 'formData');
                            this.getCanMoney();
                            this.getTableData();
                            setTimeout(() => {
                                this.canRequest = true;
                            }, 1000);
                        })
                        .catch(() => {
                            this.canRequest = true;
                        });
                }
            });
        },
        getCanMoney() {
            this.$util
                .axiosGet({
                    url: '/api/RevenueManagement/GetAvailableWithdrawalAmount',
                    data: {
                        EntpId: this.userMsg.EntpId
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    this.CanMoney = data.WithdrawCash;
                })
                .catch(() => {});
        },
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/RevenueManagement/GetWithdrawalList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => {});
        },
        showDialog() {
            this.dialogVisible = true;
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        }
    }
};
</script>
